import { clsx } from 'clsx';
import Icon from '../../Icon/Icon';
import styles from './NavButtons.module.scss';

interface NavButtonsProps {
  scrollLeft: (howFar: number) => void;
  scrollRight: (howFar: number) => void;
  showLeft: boolean;
  showRight: boolean;
  className: string;
  bgColor: string;
}

const NavButtons = ({ scrollLeft, scrollRight, showLeft, showRight, className, bgColor }: NavButtonsProps) => (
  <div className={className}>
    {showLeft && (
      <button
        className={clsx(styles.button, styles.buttonLeft, 'navButtons')}
        onClick={() => scrollLeft(2)}
        data-testid="button-left"
        aria-label="Vorherige Videos"
        style={{ background: `linear-gradient(to right, ${bgColor} 0%, rgb(0 0 0 / 0%) 100%)` }}
      >
        <Icon name="chevronLeft" size={25} />
      </button>
    )}
    {showRight && (
      <button
        className={clsx(styles.button, styles.buttonRight, 'navButtons')}
        onClick={() => scrollRight(2)}
        data-testid="button-right"
        aria-label="Nächste Videos"
        style={{ background: `linear-gradient(to right, rgb(0 0 0 / 0%) 0%, ${bgColor} 100%)` }}
      >
        <Icon name="chevronRight" size={25} />
      </button>
    )}
  </div>
);

export default NavButtons;
